<template>
    <!-- 科普手册 -->
    <div class="manual-list">
        <van-list v-model="loading" :finished="finished" finished-text="已经到底" @load="onLoad">
            <Manual v-for="item in manualList" :dataItem="item" :key="item.id" :isContent="false" :contentType="3" />
        </van-list>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import { Manual } from '@/components/contentSelection'

export default {
    components: {
        Manual
    },
    data() {
        return {
            overlayShow: false,
            loading: true,
            finished: false,
            channelList: [],
            page: {
                page: 1,
                pageSize: 10
            },
            total: 0,
            manualList: [],
            record_id: 0
        }
    },
    methods: {
        onLoad() {
          alert(1)
            this.finished = false
            this.loading = true
            this.page.page++
            this.fetch('manualList')
            Interface.getShareInfo(this, '博医同行-科普手册', '', '')
        },
        fetch(scene) {
            if (scene === 'manualList') {
                Interface.getData('get', Interface.anticancer.manualList, this.page).then(res => {
                    this.manualList = this.manualList.concat(res.data.list)
                    this.total = res.data.total
                    this.loading = false
                    // this.isLoading = false
                    if (this.manualList.length >= this.total) {
                        this.finished = true
                    }
                })
            }
        },
        onScroll() {
          let list = document.querySelector('.van-list')
          let tempArr = []
          for (let i = 0; i < list.children.length; i++){
            if (Math.abs(list.children[i].getBoundingClientRect().top) < 5) {
              let item = this.manualList[i]
              let obj = { type: 15, origin_id: item.id, title: item.title,
                page_type: 3 }
              tempArr.push(obj)
              Interface.exposureFootPrint(JSON.stringify(tempArr))
            }
          }

        }
    },
    created() {
        this.fetch('manualList')
        Interface.getData('post',Interface.footprint, {
          id: 1,
          type: 102,
          content_type: 0,
          page_type: 3,
          source_type: 0,
          parent_id: 0,
          record_id: 0,
          title: '科普手册列表页'
        }).then( (res) => {
          if (res.code == 0) {
            this.record_id = res.data.record_id
          }
        })
        Interface.CoFootPrint(15)
    },
    beforeRouteLeave(to, from, next) {
      if (this.record_id) {
        Interface.mFootPrint(1, 102,0, 3, 0, 0,this.record_id,'科普手册列表页')
      }
      next()
    }
}
</script>

<style lang="scss">
.manual-list {
    color: #333;
    border-radius: 2px;
    background: #f5f5f5;
    height: 98vh;
}
</style>



// WEBPACK FOOTER //
// src/views/anticancer/manual/list/index.vue